import { Box } from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { AssetVerificationReceivable } from './types';
import { CsvXlsxDownloadSelect } from 'packages/common-frontend/components/CsvXlsxDownloadSelect';

export const DataDownloadControl = ({
  receivables,
  label,
}: {
  receivables: AssetVerificationReceivable[];
  label: string;
}) => {
  if (receivables.length === 0) {
    return null;
  }
  // convert receivables fields into flatter format.
  const dataRows = receivables.map((receivable) => {
    const finleyRawDocId = receivable.rawIdsWithTimestamps[0]?.id ?? '-';

    const {
      lenderVerificationStatus,
      finleyReceivableId,
      externalReceivableId,
      fields,
    } = receivable;

    const flattenedFields = fields.reduce<Record<string, any>>(
      (acc, field) => {
        const { field: name, loanTapeValue, result } = field;
        const key = `field_${name}`;
        // eslint-disable-next-line no-param-reassign
        acc[key] = {
          verificationResult: result?.verificationResult ?? '-',
          loanTapeValue,
          documentSanitizedValue: result?.docSanitizedValue ?? '-',
          documentRawValue: result?.docRawValue ?? '-',
        };
        return acc;
      },
      {
        lenderVerificationStatus,
        finleyRawDocId,
        finleyReceivableId,
        externalReceivableId,
      },
    );

    return commonUtils.generateFlattenNestedKeyObject(flattenedFields, {
      manageArrayValue: 'ignore', // ignore arrays
    });
  });

  const headers = Object.keys(dataRows[0]).map((key) => ({
    key,
    label: key,
  }));

  return (
    <Box>
      {receivables.length > 0 && (
        <CsvXlsxDownloadSelect
          dataRows={dataRows}
          headers={headers}
          filenamePrefix={label}
          linkText={`Download: ${label}`}
        />
      )}
    </Box>
  );
};
